import fetch from '@/service/fetch'
import type { TypeImgConfigResponse } from '../types'

export const getImgConfig: TypeImgConfigResponse = (data = {}) => {
  return fetch({ method: 'post', url: '/config/getImgConfig', data })
}
